module.exports = __webpack_public_path__ + "img/government-right-5.577c72dd.png";